export default {
  en: {
    'ADD_ANNOTATION_SUCCESS': 'Annotation Tag Added',
    'ADD_ANNOTATION_MULTIPLE_SUCCESS': 'Annotation Tag added to the selected calls',
    'BLOCK_NUMBER_SUCCESS': 'Number successfully blocked',
    'RTB_REROUTE_BID': 'Your Bid',
    'RTB_REROUTE_NAME': 'Name',
    'RTB_REROUTE_TARGET_ID': 'Target Id',
    'RTB_REROUTE_MIN_TARGET_BID': 'Min Target Bid',
    'RTB_REROUTE_TARGET_BID': 'Target Bid',
    'RTB_REROUTE_REASON': 'Reason(s)',
    'RTB_REROUTE_VIEW_TARGET': 'View Target',
    'RTB_REROUTE_REASON_TEXT': 'Min Target Bid Not Reached',
    'UNBLOCK_NUMBER_SUCCESS': 'Number successfully unblocked',
    'PAYOUT_ADJUSTMENT_SUCCESS': 'Payout/Revenue successfully adjusted. The amounts will be updated shortly, refresh the call logs to display.',
    'PAYOUT_ADJUSTMENT_MULTIPLE_SUCCESS': 'Payout/Revenue successfully updated for the selected calls. The amounts will be updated shortly, refresh the call logs to display.',
    'PAYOUT_ADJUSTMENT_BY_LOGS_SUCCESS': 'Payout/Revenue successfully requested for the current report. The amounts will be updated shortly and a confirmation email sent.',
    'TRANSCRIBE_MULTIPLE_SUCCESS': 'Transcription successfully queued for the selected calls. The transcripts will be available shortly by clicking the Transcript icon for the call in Call Details.',
    'TRANSCRIBE_BY_LOGS_SUCCESS': 'Transcription successfully queued for the current report. The transcripts will be available shortly by clicking the Transcript icon for the call in Call Details.',
    'TRANSCRIBE_SUCCESS': 'Transcription successfully queued for the current call. The transcript will be available shortly by clicking the Transcript icon for the call in Call Details.',
    'REQUEST_CONVERSION_ADJUSTMENT_SUCCESS': 'Dispute has been submitted successfully',
    'REQUEST_CONVERSION_ADJUSTMENT_MULTIPLE_SUCCESS': 'Dispute has been successfully submitted for the selected calls',
    'SHOW_TIMELINE': 'Show Timeline',
    'HIDE_TIMELINE': 'Hide Timeline',
    'SHOW_QUICK_INSIGHTS': 'Show Quick Insights',
    'HIDE_QUICK_INSIGHTS': 'Hide Quick Insights',
    'TOUR_DONT_SHOW_AGAIN': 'Don\'t show again',
    'TOUR_SKIP': 'Skip Tour',
    'TOUR_PREVIOUS': 'Previous',
    'TOUR_NEXT': 'Next',
    'TOUR_FINISH': 'Got it',
  }
};